import { Button, Flex, Tooltip } from 'antd';
import { useMemo } from 'react';

import { ModelWarehouseInventoryState } from '@app/api/WarehouseInventories';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import { useInventoryCardContext } from '@app/providers/InventoryCardProvider/useInventoryCardContext';

import type { FC } from 'react';

export const InventoryCardHeader: FC = () => {
  const {
    inventory,
    onComplete,
    onExportToExcel,
    onLevelUpInventoryReport,
    isExportLoading,
    isLevelUpInventoryReportLoading,
    hasInventoryReportDifferences,
    isFinishButtonDisabled,
    completeDisabledTooltip,
  } = useInventoryCardContext();
  const { isMobile } = useWindowSize();

  const status = useMemo(() => {
    return inventory?.State || null;
  }, [inventory]);
  const isInProgress = useMemo(() => {
    return status === ModelWarehouseInventoryState.Open;
  }, [status]);
  const isDone = useMemo(() => {
    return status === ModelWarehouseInventoryState.Done;
  }, [status]);

  const {
    userAccessRights: {
      Warehouse: { IsInventoryComplete },
    },
  } = useNewUserAccessRights();

  if (!IsInventoryComplete) {
    return null;
  }

  return (
    <Flex
      className={`${PF}_buttons`}
      justify="space-between"
      align="center"
      gap={12}
      vertical={isMobile}
    >
      {isInProgress && (
        <Tooltip
          title={isFinishButtonDisabled ? completeDisabledTooltip : undefined}
        >
          <span className={`${isMobile ? 'full-width' : ''}`}>
            <Button
              type="primary"
              disabled={isFinishButtonDisabled}
              onClick={onComplete}
              className={`${isMobile ? 'full-width' : ''}`}
            >
              Завершить
            </Button>
          </span>
        </Tooltip>
      )}
      {isDone && hasInventoryReportDifferences && (
        <Button
          type="primary"
          loading={isLevelUpInventoryReportLoading}
          onClick={onLevelUpInventoryReport}
          className={`${isMobile ? 'full-width' : ''}`}
        >
          Выравнить остатки
        </Button>
      )}
      {isDone && (
        <Button
          type="primary"
          loading={isExportLoading}
          onClick={onExportToExcel}
          className={`${isMobile ? 'full-width' : ''}`}
        >
          Экспорт в Excel
        </Button>
      )}
    </Flex>
  );
};
